import { keyframes } from "@emotion/react";

export const fadeIn = keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

export const fadeOut = keyframes({
  from: { opacity: 1 },
  to: { opacity: 0 },
});

export const scaleIn = keyframes({
  from: { transform: "scale(0)" },
  to: { transform: "scale(1)" },
});

export const scaleOut = keyframes({
  from: { transform: "scale(1)" },
  to: { transform: "scale(0)" },
});

export const pulseSize = keyframes({
  "0%": { transform: "scale(1)" },
  "50%": { transform: "scale(1.05)" },
  "100%": { transform: "scale(1)" },
});

export const pulseOpacity = keyframes({
  "0%": { opacity: 0.5 },
  "50%": { opacity: 1 },
  "100%": { opacity: 0.5 },
});

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const opacityBlink = keyframes`
  0%, 45% { opacity: 1; }
  50%, 100% { opacity: 0; }
`;

export const shake = keyframes({
  "0%": { transform: "translateX(0)" },
  "25%": { transform: "translateX(-5px)" },
  "50%": { transform: "translateX(5px)" },
  "75%": { transform: "translateX(-5px)" },
  "100%": { transform: "translateX(0)" },
});

export const fadeInAndSlideUp = keyframes({
  from: { opacity: 0, transform: "translateY(4px)" },
  to: { opacity: 1, transform: "translateY(0)" },
});

export const growFromBottomRounded = keyframes({
  from: { clipPath: "inset(100% 0 0 0 round 6px)" },
  to: { clipPath: "inset(0 0 0 0 round 6px)" },
});

export const growFromLeftRounded = keyframes({
  from: { clipPath: "inset(0 100% 0 0 round 6px)" },
  to: { clipPath: "inset(0 0 0 0 round 6px)" },
});

export const smoothTransition = "all 0.2s ease";
